import api from './api';

const CURRENT_ANNOUNCEMENT_ENDPOINT = '/announcements/current';

export const getCurrentAnnouncement = () => api.get(CURRENT_ANNOUNCEMENT_ENDPOINT);

export const saveCurrentAnnouncement = (content) => api.put(
  CURRENT_ANNOUNCEMENT_ENDPOINT,
  { content }
);

export const clearCurrentAnnouncement = () => api.delete(CURRENT_ANNOUNCEMENT_ENDPOINT);
